import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import entete from "../../../../assets/img/entete_pool.png";
import footer from "../../../../assets/img/footer.png";
import { LOGGED_USER } from "../../../../variables/constants";
import { frenchDate } from "../../../../variables/functions";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import { DocumentFooter } from "../../../../components/docs/DocumentFooter";
import { Image } from "antd";
import BarreTop from "../../../../components/docs/BarreTop";
import { getCompagnieLogo } from "../../../../hooks/useFilesHooks";

const RecuCurrentFormat = React.forwardRef((props, ref) => {
  const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);

  const datas = [
    {
      libelle: "Prime HT :",
      valeur: `${displayNumbers(
        Math.trunc(props?.reglement?.accessoires ? (props?.reglement?.montant / (1 + 0.06)) - props?.reglement?.accessoires : (props?.reglement?.montant / (1 + 0.06)))
      )} FCFA`,
    },
    {
      libelle: "Coût de Police :",
      valeur: `${displayNumbers(
        Math.trunc(props?.reglement?.accessoires || 0)
      )} FCFA`,
    },
    {
      libelle: "Taxes :",
      valeur: `${displayNumbers(
        Math.trunc(props?.reglement?.montant * 0.06)
      )} FCFA`,
    },
    {
      libelle: "Montant total de la prime TTC :",
      valeur: `${displayNumbers(
        Math.trunc(props?.reglement?.montant)
      )} FCFA`,
    },
  ];

  const datas2 = [
    {
      libelle: `${props.reglement?.montant > 0 ? "Montant encaissé :" : "Montant ristourné :"}`,
      valeur: `${displayNumbers(
        Math.trunc(props?.reglement?.montant)
      )} FCFA`,
    },
    {
      libelle: "Montant restant :",
      valeur: `${displayNumbers(
        Math.trunc(props?.reglement?.montant - props?.reglement?.montant)
      )} FCFA`,
    },
    {
      libelle: "Mode paiement :",
      valeur: `${props?.reglement?.modePaiement}`,
    },
    {
      libelle: "Payé le :",
      valeur: `${frenchDate(props?.reglement?.dateReglement)}`,
    },
  ];

  useEffect(() => {
    getCompagnieLogo(props?.reglement?.organismeCode)
      .then(async (response) => {
        const imageBytes = await response.arrayBuffer();
        var blob = new Blob([imageBytes], { type: "image/png" });
        var imageUrl = URL.createObjectURL(blob);
        setLogoPreviewUrl(imageUrl);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props]);

  return (
    <div className="container d-flex justify-content-center" style={{ width: "100%", height: "auto", padding: "10px", boxSizing: "border-box" }}>
      <style>{`
        @media print {
          @page {
            size: A4;
            margin: 8mm;
          }
          body {
            margin: 0;
            padding: 0;
          }
          .print-container {
            page-break-inside: avoid;
          }
          .receipt-copy {
            page-break-inside: avoid;
          }
          h5 {
            font-size: 12px;
            margin: 4px 0;
            font-weight: bold;
          }
          h7, td {
            font-size: 9px;
            line-height: 1.2;
          }
          table {
            margin-bottom: 2px;
          }
          hr {
            margin: 3px 0;
          }
          .my-1 {
            margin-top: 2px !important;
            margin-bottom: 2px !important;
          }
          img {
            max-height: 60px !important;
          }
          .card {
            padding: 5px;
            margin-bottom: 5px;
          }
          .divider {
            margin: 8px 0 !important;
          }
          .signature-section {
            min-height: 40px;
          }
        }
        .card {
          border: 1px solid #ddd;
          padding: 8px;
          margin-bottom: 8px;
        }
      `}</style>
      <div className="row w-100">
        <div className="col-12 print-container" ref={ref}>
          {/* First Copy */}
          <div className="receipt-copy">
            <div style={{ flexShrink: 0 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0px",
                }}
              >
                {props?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                  <img
                    src={logoPreviewUrl}
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: "70px",
                      objectFit: "contain"
                    }}
                  />
                )}
                <img
                  src={entete}
                  alt="Entête"
                  style={{
                    width: "100%",
                    height: "70px",
                    objectFit: "contain"
                  }}
                />
              </div>
              <BarreTop />
            </div>

            <div className="card testimonial-card">
              <div className="text-center">
                <h5 style={{ margin: "4px 0" }}>
                  Reçu {props?.reglement?.montant > 0 ? "d'encaissement" : "de paiement"} - ASSURANCE AUTOMOBILE
                </h5>
              </div>
              <div>
                <div className="row">
                  <div className="col-12">
                    <table className="table" border={0}>
                      <tbody>
                        <tr>
                          <td className="text-start">
                            <h7>
                              <b>ASSURE: </b>
                              {props?.contrat?.souscripteur?.nom || props?.reglement?.nomSouscripteur}{" "}
                              {props?.contrat?.souscripteur?.prenom || props?.reglement?.prenomSouscripteur}
                            </h7>
                          </td>
                          <td></td>
                          <td className="text-end">
                            <h7>
                              <b>Avenant : </b>
                              {props?.reglement?.avenant || props?.contrat?.avenant?.nom}
                            </h7>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <hr className="my-1" /> */}
                    <table className="table">
                      <tbody>
                        <tr>
                          <td className="text-start">
                            <h7>
                              <b>N° Assuré: </b>
                              {props?.contrat?.souscripteur?.numeroAssureM || props?.contrat?.souscripteur?.numeroAssureP}
                            </h7>
                          </td>
                          <td></td>
                          <td className="text-end">
                            <h7>
                              <b>N° de Police : </b>
                              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP || props.reglement?.police || props.reglement?.numeroPolice}
                            </h7>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <hr className="my-1" /> */}
                    <table className="table">
                      <tbody>
                        <tr>
                          <td className="text-start">
                            <h7>
                              <b>Date effet: </b>
                              {frenchDate(props.contrat?.dateEffet || props.reglement?.dateEffet)}
                            </h7>
                          </td>
                          <td></td>
                          <td className="text-end">
                            <h7>
                              <b>Date échéance : </b>
                              {frenchDate(props.contrat?.dateEcheance || props.reglement?.dateEcheance)}
                            </h7>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* <hr className="my-1" /> */}

                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-5">
                    <table>
                      <tbody>
                        {datas?.map((d, id) => (
                          <tr key={id}>
                            <td className="text-start">
                              <h7><b>{d.libelle} </b></h7>
                            </td>
                            <td className="text-end">
                              <h7>{d.valeur}</h7>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-6">
                    <table>
                      <tbody>
                        {datas2?.map((d, id) => (
                          <tr key={id}>
                            <td className="text-start">
                              <h7><b>{d.libelle} </b></h7>
                            </td>
                            <td className="text-end">
                              <h7>{d.valeur}</h7>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row justify-content-end">
                  <div className="col-12 text-end">
                    <div className="signature-section">
                      <h7><b>CAISSIER : </b></h7>
                      <div style={{ height: "60px" }}></div>
                      <h7>
                        <b>{LOGGED_USER.personne.nom} {LOGGED_USER.personne.prenom}</b>
                      </h7>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DocumentFooter />
          </div>

          {/* Divider */}
          <hr className="divider" style={{ borderTop: "2px dashed #000", margin: "10px 0" }} />

          {/* Second Copy */}
          <div className="receipt-copy">
            <div style={{ flexShrink: 0 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0px",
                }}
              >
                {props?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                  <img
                    src={logoPreviewUrl}
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: "70px",
                      objectFit: "contain"
                    }}
                  />
                )}
                <img
                  src={entete}
                  alt="Entête"
                  style={{
                    width: "100%",
                    height: "70px",
                    objectFit: "contain"
                  }}
                />
              </div>
              <BarreTop />
            </div>

            <div className="card testimonial-card">
              <div className="text-center">
                <h5 style={{ margin: "4px 0" }}>
                  Reçu {props?.reglement?.montant > 0 ? "d'encaissement" : "de paiement"} - ASSURANCE AUTOMOBILE
                </h5>
              </div>
              <div>
                <div className="row">
                  <div className="col-12">
                    <table className="table" border={0}>
                      <tbody>
                        <tr>
                          <td className="text-start">
                            <h7>
                              <b>ASSURE: </b>
                              {props?.contrat?.souscripteur?.nom || props?.reglement?.nomSouscripteur}{" "}
                              {props?.contrat?.souscripteur?.prenom || props?.reglement?.prenomSouscripteur}
                            </h7>
                          </td>
                          <td></td>
                          <td className="text-end">
                            <h7>
                              <b>Avenant : </b>
                              {props?.reglement?.avenant || props?.contrat?.avenant?.nom}
                            </h7>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <hr className="my-1" /> */}
                    <table className="table">
                      <tbody>
                        <tr>
                          <td className="text-start">
                            <h7>
                              <b>N° Assuré: </b>
                              {props?.contrat?.souscripteur?.numeroAssureM || props?.contrat?.souscripteur?.numeroAssureP}
                            </h7>
                          </td>
                          <td></td>
                          <td className="text-end">
                            <h7>
                              <b>N° de Police : </b>
                              {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP || props.reglement?.police || props.reglement?.numeroPolice}
                            </h7>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <hr className="my-1" /> */}
                    <table className="table">
                      <tbody>
                        <tr>
                          <td className="text-start">
                            <h7>
                              <b>Date effet: </b>
                              {frenchDate(props.contrat?.dateEffet || props.reglement?.dateEffet)}
                            </h7>
                          </td>
                          <td></td>
                          <td className="text-end">
                            <h7>
                              <b>Date échéance : </b>
                              {frenchDate(props.contrat?.dateEcheance || props.reglement?.dateEcheance)}
                            </h7>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* <hr className="my-1" /> */}

                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-5">
                    <table>
                      <tbody>
                        {datas?.map((d, id) => (
                          <tr key={id}>
                            <td className="text-start">
                              <h7><b>{d.libelle} </b></h7>
                            </td>
                            <td className="text-end">
                              <h7>{d.valeur}</h7>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-6">
                    <table>
                      <tbody>
                        {datas2?.map((d, id) => (
                          <tr key={id}>
                            <td className="text-start">
                              <h7><b>{d.libelle} </b></h7>
                            </td>
                            <td className="text-end">
                              <h7>{d.valeur}</h7>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row justify-content-end">
                  <div className="col-12 text-end">
                    <div className="signature-section">
                      <h7><b>CAISSIER : </b></h7>
                      <div style={{ height: "60px" }}></div>
                      <h7>
                        <b>{LOGGED_USER.personne.nom} {LOGGED_USER.personne.prenom}</b>
                      </h7>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DocumentFooter />
          </div>
        </div>
      </div>
    </div>
  );
});

RecuCurrentFormat.propTypes = {
  contrat: PropTypes.object,
  reglement: PropTypes.object,
};
export default RecuCurrentFormat;